export default __webpack_public_path__ + "static/media/blog-img.e9154aad.svg";